import { useContext } from 'react';

import { PaginationContext } from '../providers/PaginationProvider';

const usePagination = () => {
  return useContext(PaginationContext);
};

export default usePagination;
